import { ShieldCheckIcon, MapTrifoldIcon, RobotIcon, GraduationCap } from '@phosphor-icons/react';

export const TOOLS = [
    {
        id: 'privacy-check',
        name: 'Privacy Check',
        description: 'Verifica se un documento contiene dati sensibili secondo le policy aziendali',
        icon: ShieldCheckIcon,
        color: 'text-blue-600',
        bgColor: 'bg-blue-50',
        borderColor: 'border-blue-200',
        path: '/tools/privacy-check'
    },
    {
        id: 'company-mapping',
        name: 'Mappatura Aziendale',
        description: 'Scopri quali integrazioni IA servono negli uffici e flussi operativi',
        icon: MapTrifoldIcon,
        color: 'text-green-600',
        bgColor: 'bg-green-50',
        borderColor: 'border-green-200',
        path: '/tools/company-mapping'
    },
    {
        id: 'assistant-creator',
        name: 'Creatore Assistenti',
        description: 'Crea assistenti personalizzati in modo automatico',
        icon: RobotIcon,
        color: 'text-purple-600',
        bgColor: 'bg-purple-50',
        borderColor: 'border-purple-200',
        path: '/tools/assistant-creator'
    },
    {
        id: 'ai-trainer',
        name: 'Formatore AI',
        description: 'Formazione interattiva sulla intelligenza artificiale',
        icon: GraduationCap,
        color: 'text-orange-600',
        bgColor: 'bg-orange-50',
        borderColor: 'border-orange-200',
        path: '/tools/ai-trainer'
    }
];
